import type { TourProps } from 'antd';
import { App, Tour } from 'antd';
import React, { useEffect } from 'react';
import { useTourStore } from '../utils/tour';
import { useTranslation } from 'react-i18next';

interface GuideTourProps {
  tourId: string;
  steps: TourProps['steps'];
  autoStart?: boolean;
  showFloatButton?: boolean;
  buttonPosition?: { right?: number; bottom?: number; left?: number; top?: number };
}

const GuideTour: React.FC<GuideTourProps> = ({
  tourId,
  steps,
  autoStart = false,
}) => {
  const { message } = App.useApp();
  const {
    isTourOpen,
    activeTourId,
    hasSeenTour,
    openTour,
    closeTour
  } = useTourStore();
  const { t } = useTranslation('common');

  const isCurrentTourOpen = isTourOpen && activeTourId === tourId;
  const hasSeenCurrentTour = hasSeenTour(tourId);

  useEffect(() => {
    if (autoStart && !hasSeenCurrentTour) {
      // Delay a bit to ensure the page is fully loaded
      setTimeout(() => {
        openTour(tourId);
      }, 500);
    }
  }, [tourId, autoStart, hasSeenCurrentTour, openTour]);

  const handleTourClose = () => {
    closeTour();
  };



  const handleTourFinish = () => {
    closeTour();
    message.success(t('guide_tour.completed'), 3);
  };

  return (
    <>
      <Tour
        open={isCurrentTourOpen}
        onClose={handleTourClose}
        onFinish={handleTourFinish}
        steps={steps}
        indicatorsRender={(current, total) => (
          <span style={{ 
            color: '#1890ff', 
            fontWeight: 'bold',
            fontSize: '14px'
          }}>
            {current + 1} / {total}
          </span>
        )}
        arrow={true}
        zIndex={2000}
        styles={activeTourId === 'protomia' ? {
          section:{
            width: '800px',
            left: '-100px',
            maxHeight: '100vh',
            overflowY: 'auto',
          }
        }:{}}
        scrollIntoViewOptions={{
          behavior: 'smooth',
          block: 'center',
        }}
      />
    </>
  );
};

export default GuideTour;
